export const iconClasses = [
  'removeIcon',
  'removeIconHover',
  'removeIconActive',
  'addIcon',
  'addIconHover',
  'addIconActive',
  'searchButton',
  'searchButtonHover',
  'searchButtonActive',
  'decIcon',
  'incIcon',
  'trashIcon',
  'trashIconHover',
  'trashIconActive',
  'customIcon',
]
